import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { isValidString } from '@pineapplelab/util';
import { UserService } from '../../services/user/user.service';
import { RouteEnum } from '../../enums/routes.enum';
import { BrowserStorage } from '../../models/browserStorage';
import { ConfigService } from '../../services/config/config.service';

export const ssoGuard: CanActivateFn = async (route, state) => {
	const authService = inject(AuthService);
	const userService = inject(UserService);
	const router = inject(Router);
	const configService = inject(ConfigService);

	if (!!configService.getConfig()?.maintenanceMode?.active) {
		router.navigateByUrl('/maintenance');
		return false;
	}

	const ssoToken = route?.queryParams?.['token'];
	if (!isValidString(ssoToken)) {
		return true;
	}

	const isLoggedIn = !!BrowserStorage.get('userToken');
	if (isLoggedIn) {
		await authService.logout(`/${RouteEnum.SSO}`);
	}
	try {
		const accessToken = await authService.getAccessTokenFromSSO(ssoToken);
		await authService.afterLoginActions(accessToken);

		const url = userService.getFirstAvailableRouteByRole(authService.auth?.user?.role);
		router.navigateByUrl(url);
		return true;
	} catch (error: any) {
		router.navigateByUrl(`/${RouteEnum.LINK_EXPIRED}`);
		return false;
	}
};
